import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CounterSection = styled.section`
  background: ${props => props.theme.colors.primary};
  padding: 80px 10%;
  
  /* ✅ 수정: 양 끝 분산 대신 중앙 정렬로 변경 */
  display: flex;
  justify-content: center; 
  align-items: center;
  gap: 100px; /* 항목 사이의 간격을 명시적으로 조절 */
  color: white;

  @media (max-width: 1024px) {
    gap: 50px; /* 태블릿에서는 간격을 좁힘 */
  }

  @media (max-width: 768px) {
    flex-direction: column; /* 모바일에서는 세로로 쌓음 */
    gap: 40px;
    padding: 60px 0;
  }
`;

const Stat = styled.div`
  /* ✅ 내부 텍스트 및 요소들도 중앙 정렬 */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 150px; /* 일정한 너비 확보 */

  h4 { 
    font-size: 3.5rem; 
    font-weight: 800; 
    margin-bottom: 5px;
    letter-spacing: -1px;
  }
  
  p { 
    font-size: 1.1rem; 
    opacity: 0.9;
    font-weight: 500;
  }
`;

const CountItem = ({ target, label, suffix = '+' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(target);
    const duration = 2000; // 2초 동안 애니메이션
    const increment = end / (duration / 16); // 60fps 기준

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [target]);

  return (
    <Stat>
      <h4>{count}{suffix}</h4>
      <p>{label}</p>
    </Stat>
  );
};

const Counter = () => (
  <CounterSection>
    <CountItem target="150" label="누적 프로젝트 수" />
    <CountItem target="5" label="보유 전문 면허" suffix="" />
    <CountItem target="98" label="고객 만족도 (%)" />
  </CounterSection>
);

export default Counter;